import { Add, Check } from '@mui/icons-material';
import { Badge, Fab, Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';

import { useMenu } from '~/hooks/useMenu';
import {
  MyWorkspaceWidgetNames,
  getWorkspaceRoleWidgets,
} from '~/scenes/MyWorkspace/components/Widgets/data';
import {
  WidgetSettings,
  WorkspaceSettings,
} from '~/scenes/MyWorkspace/userSettings';

import { addWidget } from '../../../../layoutSlice';
import { myWorkspaceWidgetsMap } from '../../../Widgets/data/widgetsMap';

import { useSxStyles } from './useStyles';

type PropsType = {
  workspaceSettings: WorkspaceSettings;
};

type WidgetSettingsIndexed = {
  [key in MyWorkspaceWidgetNames]: WidgetSettings;
};

export const AddWidgetMenu = (props: PropsType) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const dispatch = useDispatch();

  const { workspaceSettings } = props;
  const displayedWidgets = workspaceSettings.widgets.reduce((acc, wss) => {
    return { ...acc, [wss.widget]: wss };
  }, {} as WidgetSettingsIndexed);
  const widgetRole = workspaceSettings.restrictToRoles[0];
  const widgetNameList = getWorkspaceRoleWidgets(widgetRole);

  const {
    anchorEl: menuAnchorEl,
    open: handleMenuOpen,
    close: handleMenuClose,
  } = useMenu();

  return (
    <>
      <Fab
        aria-controls="add-widget-menu"
        aria-haspopup="true"
        color="primary"
        onClick={handleMenuOpen}
        sx={sxStyles.fab}
      >
        <Add />
      </Fab>

      <Menu
        id="add-widget-menu"
        anchorEl={menuAnchorEl}
        open={!!menuAnchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
      >
        {widgetNameList.map((widgetName) => {
          return (
            <MenuItem
              key={widgetName}
              onClick={() => {
                dispatch(
                  addWidget({
                    id: uuidV4(),
                    widget: widgetName,
                    isVisible: true,
                  }),
                );

                handleMenuClose();
              }}
              disabled={!!displayedWidgets[widgetName]}
            >
              {displayedWidgets[widgetName] && (
                <Badge
                  badgeContent={1}
                  invisible
                  sx={sxStyles.checkBadge}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                >
                  <Check />
                </Badge>
              )}
              {t(myWorkspaceWidgetsMap[widgetName].title)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
